import { Grid } from "../../../common/utils/mui-imports";
import { ArrowDown2, ArrowDown3, ArrowUp3 } from "iconsax-react";
import { useEffect, useState } from "react";
import { EnumSortTypes, EnumStatus } from "../../../common/enums/common.enums";
import {
  DropDownDTO,
  SortDropDownDTO,
} from "../../../common/types/common.dto.types";
import useOutsideClick from "../../../core/hooks/useOutsideClick";
import { HPRTypeAndStatusSectionProps } from "./HPRTypeAndStatusSection.Types";

// ==============================|| COMPONENTS - COMMON - HPRSTATUS ||============================== //
const HPRTypeAndStatusSection = (props: HPRTypeAndStatusSectionProps) => {
  const [selectedSortState, setSelectedSortState] = useState<SortDropDownDTO>(
    props.InitialSortByState
  );
  const [selectedTypeId, setSelectedTypeId] = useState<string>("0");
  const [selectedStatus, setSelectedStatus] = useState<EnumStatus>(
    EnumStatus.Published
  );
  const [isInspectionSetsSelect, setIsInspectionSetsSelect] = useState<boolean>(
    props.isclickedInspectionSets ?? false
  );

  const selectedPerPage = props.HidePerPage
    ? ""
    : props.defaultValue
    ? props.defaultValue
    : props.PerPageItemList[1].Label;

  const [listDisplayState, setListDisplayState] = useState<"none" | "block">(
    "none"
  );
  const [listPageDisplayState, setPageListDisplayState] = useState<
    "none" | "block"
  >("none");

  const ref = useOutsideClick(() => {
    setListDisplayState("none");
  });

  const perPageRef = useOutsideClick(() => {
    setPageListDisplayState("none");
  });

  useEffect(() => {
    if (props.searchButtonClicked) {
      setSelectedTypeId("0");
      setSelectedStatus(EnumStatus.All);
    } else {
      setSelectedTypeId("1");
      setSelectedStatus(EnumStatus.Published);
    }
  }, [props.searchButtonClicked]);

  const handleSelect = (id: string) => {
    setSelectedTypeId(id);
    setSelectedStatus(EnumStatus.Published);
    props.onClickAssessmentType?.(id);
  };

  const onChangeSortBy = (event: SortDropDownDTO) => {
    if (props.onChangeSortBy) {
      if (
        selectedSortState.Label !== event.Label ||
        selectedSortState.SortType !== event.SortType
      ) {
        setSelectedSortState(event);
        props.onChangeSortBy(event);
      }
    }
  };

  const [selectedPerPageState, setSelectedPerPageState] =
    useState<string>(selectedPerPage);

  const onChangePerPage = (event: DropDownDTO) => {
    if (props.onChangePerPage) {
      if (selectedPerPageState !== event.Label) {
        setSelectedPerPageState(event.Label);
        props.onChangePerPage(props.Name, event.Value as string);
      }
    }
  };

  const toggleDisplayStyle = (type: string) => {
    if (type == "SortBy") {
      setListDisplayState((prevDisplayStyle) =>
        prevDisplayStyle === "none" ? "block" : "none"
      );
    } else {
      setPageListDisplayState((prevDisplayStyle) =>
        prevDisplayStyle === "none" ? "block" : "none"
      );
    }
  };

  function toggleSortType() {
    props.onChangeSortBy({
      ...selectedSortState,
      SortType:
        selectedSortState.SortType === EnumSortTypes.Ascending
          ? EnumSortTypes.Descending
          : EnumSortTypes.Ascending,
    });
    setSelectedSortState((prevState) => ({
      ...prevState,
      SortType:
        prevState.SortType === EnumSortTypes.Ascending
          ? EnumSortTypes.Descending
          : EnumSortTypes.Ascending,
    }));
  }
  const statusDisplayColor = {
    [EnumStatus.All]: "all",
    [EnumStatus.Published]: "published",
    [EnumStatus.Draft]: "draft",
    [EnumStatus.Deactivated]: "deactivated",
  };

  return (
    <>
      <div className="standarded-tags">
        {/* Assesment type */}
        <div className="">
          {isInspectionSetsSelect && props.ShowAssessmentType && (
            <Grid container className="pt-5 assessment-type-wrap">
              {props.AssessmentTypeList && (
                <label className="mr-5 fx flex-right type-name">Type: </label>
              )}
              <div
                className="mb-5 d-flex font-14"
                style={{
                  borderRight: "unset",
                  borderLeft: "unset",
                  zIndex: "10",
                }}
              >
                <Grid container rowGap={0.5}>
                  {props.AssessmentTypeList && (
                    <>
                      {/* "All" Option */}
                      <div
                        className="standards-status"
                        onClick={() => handleSelect("0")}
                      >
                        <span
                          className={`status-color all cursor-pointer ${
                            selectedTypeId === "0" ? "active" : ""
                          }`}
                        >
                          All
                        </span>
                      </div>
                    </>
                  )}

                  {/* Render assessment types */}
                  {isInspectionSetsSelect &&
                    props.AssessmentTypeList &&
                    props.AssessmentTypeList.map((item) => (
                      <div
                        className="standards-status"
                        key={item.Id}
                        onClick={() => handleSelect(item.GroupId)}
                      >
                        <span
                          className={`status-color cursor-pointer all ${
                            selectedTypeId === item.GroupId ? "active" : ""
                          }`}
                        >
                          {item.LatestCode}
                        </span>
                      </div>
                    ))}
                </Grid>
              </div>
            </Grid>
          )}
        </div>
        <Grid container columns={12}>
          {/* Status */}
          {!isInspectionSetsSelect ? (
            <Grid
              item
              lg={6}
              md={6}
              sm={6}
              xs={5}
              className="standards-status font-14"
            >
              <label>Status: </label>
              {props.StatusSummaryItemList &&
                props.StatusSummaryItemList.map((item) => {
                  return (
                    <span
                      key={`Status_${item.Value}_${item.Value}`}
                      className={`status-color ${
                        statusDisplayColor[item.Value]
                      } ${selectedStatus === item.Value ? "active" : ""}`}
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        setSelectedStatus(item.Value);
                        props.onClickStatus?.(item.Value);
                      }}
                    >
                      {item.Label}
                      {item.StatusSummaryCount || item.StatusSummaryCount === 0
                        ? `(${item.StatusSummaryCount})`
                        : ""}
                    </span>
                  );
                })}
            </Grid>
          ) : (
            <Grid
              item
              lg={6}
              md={6}
              sm={6}
              xs={5}
              className="standards-status actual-status font-14"
            >
              {props.AssessmentTypeList && <label>Status: </label>}
              {props.StatusSummaryItemList &&
                props.StatusSummaryItemList.filter((statusItem) =>
                  props.StatusList?.some(
                    (status) => status.Id === statusItem.Value
                  )
                ).map((item) => {
                  const matchingStatus = props.StatusList?.find(
                    (status) => status.Id === item.Value
                  );
                  // remove status color
                  // ${statusDisplayColor[item.Value]}
                  return (
                    <span
                      key={`Status_${item.Value}_${item.Value}`}
                      className={`${statusDisplayColor[item.Value]} ${
                        selectedStatus === item.Value ? "tags-active" : ""
                      }`}
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        setSelectedStatus(item.Value);
                        props.onClickStatus?.(item.Value);
                      }}
                    >
                      {item.Label}{" "}
                      {item.StatusSummaryCount || item.StatusSummaryCount === 0
                        ? `(${item.StatusSummaryCount})`
                        : ""}
                      {matchingStatus?.Count || matchingStatus?.Count === 0
                        ? `(${matchingStatus.Count})`
                        : ""}
                    </span>
                  );
                })}
            </Grid>
          )}

          <Grid item lg={6} md={6} sm={6} xs={7} className="">
            {!props.HideSortBy ? (
              <>
                <div className="sortOpt p-r-10">
                  <label className="sort-label" style={{ padding: "0 15px" }}>
                    Sort by
                  </label>
                  <div className="p-r-5 flex--container height-32">
                    <div
                      ref={ref}
                      className="valign-middle p-r-5"
                      onClick={() => toggleDisplayStyle("SortBy")}
                      style={{ position: "relative" }}
                    >
                      {selectedSortState.Label}
                      <ArrowDown2
                        size={14}
                        style={{ position: "relative", top: 1 }}
                        className="p-l-5"
                      />
                      <div
                        className="drop-items"
                        style={{
                          display: listDisplayState,
                          right: -10,
                          top: 31,
                          minWidth: 115,
                          width: "max-content",
                          maxWidth: 250,
                        }}
                      >
                        <ul>
                          {props.SortByItemList?.sort((a, b) =>
                            a.Label.localeCompare(b.Label)
                          ).map((item, index) => (
                            <li
                              key={index}
                              onClick={() => onChangeSortBy(item)}
                            >
                              <a className="flex--container">
                                <label className="flex__item text-left vcenter">
                                  {item.Label}
                                </label>
                              </a>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                    {/*Toggle sort button start*/}
                    <div
                      className="p-l-10"
                      // title={
                      //   selectedSortState.SortType === EnumSortTypes.Descending
                      //     ? "Descending"
                      //     : "Ascending"
                      // }
                      onClick={() => toggleSortType()}
                    >
                      <div title="Ascending">
                        <ArrowUp3
                          size={14}
                          className={`order${
                            selectedSortState.SortType ===
                            EnumSortTypes.Ascending
                              ? " ascending"
                              : ""
                          }`}
                          style={{ position: "relative", top: 2 }}
                        />
                      </div>
                      <div title="Descending">
                        <ArrowDown3
                          size={14}
                          className={`order${
                            selectedSortState.SortType ===
                            EnumSortTypes.Descending
                              ? " descending"
                              : ""
                          }`}
                          style={{ position: "relative", top: -10 }}
                        />
                      </div>
                      {/* )} */}
                    </div>
                    {/*Toggle sort button end*/}
                  </div>
                </div>
              </>
            ) : (
              <></>
            )}
            {!props.HidePerPage ? (
              <>
                <div className="sortOpt text-center m-r-10 p-r-10">
                  <label className="sort-label">Per page</label>

                  <div>
                    <div
                      ref={perPageRef}
                      onClick={() => toggleDisplayStyle("PerPageData")}
                      style={{ position: "relative" }}
                    >
                      {selectedPerPageState}
                      {/* <KeyboardArrowDown style={{ position: "relative", top: 0 }} /> */}
                      <ArrowDown2
                        size={14}
                        style={{ position: "relative", top: 3 }}
                        className="p-l-5"
                      />

                      <div
                        className="drop-items"
                        style={{
                          display: listPageDisplayState,
                          width: 50,
                        }}
                      >
                        <ul>
                          {props.PerPageItemList?.map((item, index) => (
                            <li
                              key={index}
                              onClick={() => onChangePerPage(item)}
                            >
                              <a>{item.Label}</a>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <></>
            )}
          </Grid>
        </Grid>
      </div>
    </>
  );
};

export default HPRTypeAndStatusSection;
